import "./WhitePapersLanding.css";

export default function WPButton({ label, action = "#", variant = "default", customClass, target, disabled }) {
    return (
        <a
            className={`${customClass} ${disabled ? 'disabled' : ''}`}
            href={disabled ? null : action}  // Set href to null if disabled
            target={target}
            aria-disabled={disabled}
            onClick={(e) => {
                if (disabled) {
                    e.preventDefault();
                }
            }}
        >
            {label}
        </a>
    );
}
